import React from 'react';
import SafeHtml  from "../../custom-components/SafeHtml/SafeHtml"

interface HeadingProps {
    text: string;
    tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span" | "div";
}

const Heading: React.FC<HeadingProps> = ({ text = "Enter some heading here...", tag }) => {
    return (
        <SafeHtml
             as={tag}
             html={text}
             className='builder-io-heading-component'
        />
    );
};

export default Heading;

export const headingRegistration = {
    name: "Heading ",
    inputs: [
        { 
            name: "text",
            type: "richText",
        },
        { 
            name: "tag",
            type: "text",
        },
    ],
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/format-text.svg',
    description: 'Add a heading component to the page',
}